import { Chip, Stack, styled, Typography } from '@mui/material';

interface StyledContainerProps {
  hasUploadedAudio?: boolean;
}

export const StyledContainer = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'hasUserAudio',
})<StyledContainerProps>(({ theme, hasUploadedAudio }) => ({
  cursor: hasUploadedAudio ? 'auto' : 'pointer',
  width: '100%',
  alignItems: 'center',
  padding: '1px',
  borderRadius: theme.spacing(1),
  background: `linear-gradient(to right, #26f7c5, #8895fa)`,
}));

export const StyledGlassBox = styled(Stack)(({ theme }) => ({
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(1.75),
  background: 'rgba( 0, 0, 0, 0.6 )',
  backdropFilter: `blur( 18.5px )`,
  '-webkit-backdrop-filter': `blur( 18.5px )`,
  borderRadius: theme.spacing(1),
}));

export const StyledWrapper = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
});

export const StyledChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  color: theme.palette.grey[900],
  marginRight: theme.spacing(1),
}));

export const StyledInfoTypography = styled(Typography)({
  fontSize: '12px',
});

export const StyledStateBox = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  '& svg': {
    path: { fill: 'inherit' },
  },
});

export const StyledStateTypography = styled(StyledInfoTypography)(
  ({ theme }) => ({
    marginLeft: theme.spacing(0.5),
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  })
);
